/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import MovieList from "../movieList/movieList";
import { connect } from "react-redux";
import LoadingIndicator from "../loadingIndicator/loadingIndicator";
import ErrorBoundry from "../errorBoundry/errorBoundry";
import { fetchPlayingMovies } from "../../store/playing/actions";
import { getPlaying } from "../../store/playing/selector";
import { loadMore } from "../../store/playing/actions";

const Playing = ({
  fetchPlaying,
  loading,
  error,
  moviesPlaying,
  page,
  loadMoreReq,
  slice
}) => {
  useEffect(() => {
    fetchPlaying(page);
  }, []);

  if (loading) {
    return <LoadingIndicator />;
  }

  if (error) {
    return <ErrorBoundry />;
  }

  if (slice) {
    return <MovieList movies={moviesPlaying.slice(0, 5)} />;
  }

  const getMore = () => loadMoreReq(page + 1);

  return (
    <>
      <MovieList movies={moviesPlaying} />
      <div className="load-more-wrap">
        <button className="load-more" type="button" onClick={getMore}>
          Load More
        </button>
      </div>
    </>
  );
};

const mapState = state => {
  return {
    moviesPlaying: getPlaying(state),
    loading: state.playing.loading,
    error: state.playing.loading,
    page: state.playing.page
  };
};

const mapDispatch = {
  fetchPlaying: fetchPlayingMovies,
  loadMoreReq: loadMore
};

export default connect(mapState, mapDispatch)(Playing);
